import { ConfirmedGraftsTable } from '@/components/Templates/Utilities/ConfirmedGrafts';

const ConfirmedGrafts = () => {
  return (
    <ConfirmedGraftsTable />
  )
}

export default ConfirmedGrafts;
